<template>
	<div class="read-more">
		<div class="article__description"
			 ref="content"
			 :class="{'article__description--small': !showButton}"
			 :style='[showButton ? opened ? {maxHeight: setMaxHeight} : {maxHeight: styleHeight} : "" ]'>
			<slot></slot>
		</div>
		<button type="button" role="button" class="btn--arrow-down"
				v-show="showButton"
			@click="opened = !opened">Button open</button>
	</div>

</template>

<script>
	export default {
		props: {
			propHeight: {
				type: Number,
				required: true,
			},
			indexTab: {
				default: 0,
			}
		},

		data() {
			return {
				opened: false,
				setMaxHeight: 600 + 'px',
				styleHeight: this.propHeight + "px",
				showButton: false,
			}
		},

		mounted() {
			this.getElementHeight;
		},

		methods: {
			getElementHeight() {
				this.setMaxHeight = this.$refs.content.scrollHeight + "px";

				if(this.$refs.content.scrollHeight > this.propHeight + 20) {
					this.showButton = true;
				}
			}
		},

		watch: {
			indexTab() {
				this.getElementHeight();
			}
		}
	};
</script>

